import { createSelector } from 'reselect';
import ReceptaclesInPredesNotInPreconDetailsColumns
  from '../../containers/ReceptaclesInPredesNotInPreconDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .RECEPTACLES_IN_PREDES_NOT_IN_PRECON_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .RECEPTACLES_IN_PREDES_NOT_IN_PRECON_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .RECEPTACLES_IN_PREDES_NOT_IN_PRECON_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, ReceptaclesInPredesNotInPreconDetailsColumns);
